/* Modish (Global): fit product photos inside their frames.
   Reads a 48px copy of each loaded product image and finds the product.
   - Product cards (collection, search, sliders), 19 Oct 2026: every photo on a white background is
     zoomed and centred so the product fills ~88% of the frame (supplier photos carry wide white margins;
     OW bags fill ~62% of the photo). Photos on grey or model backgrounds are left untouched.
   - Product-page gallery: unchanged - only photos that sit low in a white frame are shifted and gently enlarged.
   Ported from the India theme; frame maths handle both object-fit: cover (Desert cards) and contain. */
(function () {
  var SEL = '.product-card-wrapper .media-wrapper img, .product-gallery-slider .media-wrapper img, .product-gallery-thumb-item .media-wrapper img, media-gallery .media-wrapper img';
  var CARD = '.product-card-wrapper .media-wrapper img';
  var cache = {};
  function key(img) { return ((img.currentSrc || img.src || '').split('?')[0]); }
  function lum(d, i) { return 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; }
  function analyse(img) {
    var k = key(img);
    if (!k) return null;
    if (k in cache) return cache[k];
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var w = 48, h = Math.max(1, Math.round(48 * nh / nw));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }), d;
    try { x.drawImage(img, 0, 0, w, h); d = x.getImageData(0, 0, w, h).data; } catch (e) { cache[k] = null; return null; }
    var t = h, b = -1, l = w, r = -1;
    for (var yy = 0; yy < h; yy++) {
      for (var xx = 0; xx < w; xx++) {
        var i = (yy * w + xx) * 4;
        if (d[i + 3] > 10 && lum(d, i) < 236) {
          if (yy < t) t = yy; if (yy > b) b = yy; if (xx < l) l = xx; if (xx > r) r = xx;
        }
      }
    }
    // white background = all four corners near pure white (so moving the photo never shows a seam)
    var white = true, cs = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
    for (var j = 0; j < 4; j++) { if (lum(d, cs[j]) < 246) white = false; }
    cache[k] = b < 0 ? null : { t: t / h, b: (b + 1) / h, l: l / w, r: (r + 1) / w, ar: nw / nh, white: white };
    return cache[k];
  }
  function apply(img) {
    if (!img || img.tagName !== 'IMG' || img.dataset.mdRc || !img.matches(SEL)) return;
    if (!img.clientWidth || !img.clientHeight) return;
    var p = analyse(img);
    if (!p) return;
    img.dataset.mdRc = '1';
    var card = img.matches(CARD);
    var cy = (p.t + p.b) / 2;
    if (card) { if (!p.white) return; }
    else if (!(p.t > 0.2 && cy > 0.58)) return;
    var ca = img.clientWidth / img.clientHeight;            // frame width in units of frame height
    var cover = getComputedStyle(img).objectFit === 'cover';
    var rw, rh;
    if ((p.ar > ca) !== cover) { rw = ca; rh = ca / p.ar; } else { rh = 1; rw = p.ar; }
    var ox = (ca - rw) / 2, oy = (1 - rh) / 2;
    var x0 = Math.max(0, ox + p.l * rw), x1 = Math.min(ca, ox + p.r * rw);
    var y0 = Math.max(0, oy + p.t * rh), y1 = Math.min(1, oy + p.b * rh);
    if (x1 <= x0 || y1 <= y0) return;
    var fill = card ? 0.88 : 0.86, cap = card ? 1.8 : 1.35;
    var s = Math.min(fill * ca / (x1 - x0), fill / (y1 - y0));
    s = Math.max(1, Math.min(cap, s));
    var tx = (ca / 2 - s * (x0 + x1) / 2) / ca * 100, ty = (0.5 - s * (y0 + y1) / 2) * 100;
    if (s < 1.02 && Math.abs(tx) < 2 && Math.abs(ty) < 2) return;   // already fills and is centred
    img.style.transformOrigin = '0 0';
    img.style.transform = 'translate(' + tx.toFixed(2) + '%,' + ty.toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
    img.classList.add('md-rc');
    // ask for a sharper file when the photo is enlarged on a card
    if (card && s > 1.05 && img.getAttribute('srcset')) img.sizes = Math.ceil(img.clientWidth * s) + 'px';
  }
  document.addEventListener('load', function (e) { apply(e.target); }, true);
  function scan() { document.querySelectorAll(SEL).forEach(function (img) { if (img.complete && img.naturalWidth) apply(img); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  // infinite scroll / filter updates add new cards
  var q = 0;
  new MutationObserver(function () { if (q) return; q = requestAnimationFrame(function () { q = 0; scan(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
